import React, { useState } from 'react';
import ContentCard from '../ContentCard';
import NoticeCard from '../NoticeCard';
import PersonIcon from '@mui/icons-material/Person';
import BusinessCenter from '@mui/icons-material/BusinessCenter';
import AlternateEmail from '@mui/icons-material/AlternateEmail';
import PersonSearch from '@mui/icons-material/PersonSearch';
import LocationOn from '@mui/icons-material/LocationOn';
import Call from '@mui/icons-material/Call';
import PhonelinkIcon from '@mui/icons-material/Phonelink';
import WifiIcon from '@mui/icons-material/Wifi';
import WebIcon from '@mui/icons-material/Web';
import LanguageIcon from '@mui/icons-material/Language';
import PhonelinkSetupIcon from '@mui/icons-material/PhonelinkSetup';
import GroupIcon from '@mui/icons-material/Group';

const ProcessingAndLegalBasis = () => {
    const [expandedCard, setExpandedCard] = useState(null); // State to track the currently expanded card

    const handleAccordionChange = (panel) => (event, isExpanded) => {
        setExpandedCard(isExpanded ? panel : null);
    };

    return (
        <div className='left-align'>
<ContentCard
    title="Our Processing and the Legal Basis for It"
    content={
        <>
            <p>Below, you'll find details on why we collect specific information and the legal basis for processing that information.</p>
            <p>Click to expand the relevant section:</p>
            <NoticeCard
                whatWeCollect={["Your IP Address", "Device Type", "Browser Type", "Broad Geographic Location", "Other Technical Information"]}
                icons={[WifiIcon, PhonelinkIcon, WebIcon, LanguageIcon, PhonelinkSetupIcon]}
                description={<p>This information is used to provide our legal services to you as a client. We will also process identification and background information in our administrative and marketing processes, including anti-money laundering and conflict checks. The information our clients provide may be disclosed to third parties to the extent that is reasonably necessary in connection with that work.</p>}
                legalBasis={
                    <>
                        <p><u>Legitimate Interest:</u> We have balanced these interests against your rights and freedoms.</p>
                        <p><u>Consent:</u> You have consented to the personal data processing through accepting the use of our Cookies.</p>
                    </>
                }
                whoWeShareItWith={<p>Only our team and select service providers involved in operating our business.</p>}
                userControl={<p>You have the right to object to this processing. We will cease processing unless we can demonstrate compelling legitimate grounds.</p>}
                expanded={expandedCard === 'panel1'}
                onChange={handleAccordionChange('panel1')}
            />

            <br></br>

            <NoticeCard
                whatWeCollect={["Your Name", "Job Title", "Employer Name", "Work Address", "Email", "Phone Number"]}
                icons={[PersonIcon, PersonSearch, BusinessCenter, LocationOn, AlternateEmail, Call]}
                description={<p>This information is used to provide our legal services to you as a client. We will also process identification and background information in our administrative and marketing processes, including anti-money laundering and conflict checks. The information our clients provide may be disclosed to third parties to the extent that is reasonably necessary in connection with that work.</p>}
                legalBasis={
                    <>
                        <p><u>Consent:</u> You have consented to the personal data processing.</p>
                        <p><u>Contract:</u> You have a contract or are entering into a contract with Privacy.</p>
                        <p><u>Legitimate Interest:</u> We have balanced these interests against your rights and freedoms.</p>
                    </>
                }
                whoWeShareItWith={<p>Only our team and select service providers involved in operating our business.</p>}
                userControl={<p>You have the right to object to this processing. We will cease processing unless we can demonstrate compelling legitimate grounds.</p>}
                expanded={expandedCard === 'panel2'}
                onChange={handleAccordionChange('panel2')}
            />

            <br></br>
            <NoticeCard
                whatWeCollect={["Third-Party Personal Data"]}
                icons={[GroupIcon]}
                description={<p>Sometimes, we receive information about individuals involved that is not provided directly by them.</p>}
                legalBasis={
                    <>
                        <p><u>Legitimate Interest:</u> Based on our legitimate interest in conducting our business and performing our engagements. We have balanced these interests against your rights and freedoms.</p>
                    </>
                }
                whoWeShareItWith={<p>Only our team and select service providers involved in operating our business.</p>}
                userControl={<p>You have the right to object to this processing. We will cease processing unless we can demonstrate compelling legitimate grounds.</p>}
                expanded={expandedCard === 'panel3'}
                onChange={handleAccordionChange('panel3')}
            />

                        {/* You can add more NoticeCard components as needed */}
                    </>
                }
            />
        </div>
    );
};

export default ProcessingAndLegalBasis;
